import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

import { HOME_SPORT_GROUPS } from '../../pages/home/constants/home-sport-groups.constant'
import { BetConfigEntry } from '../types/bet.type'

@Injectable({
	providedIn: 'root',
})
export class BetConfigService {
	betConfig$ = new BehaviorSubject<Record<string, BetConfigEntry> | null>(this.loadFromStorage())

	resolveConfig(
		betConfig: Record<string, BetConfigEntry> | null,
		sportId: number | string | undefined,
		marketType?: 'autoBm' | 'bookmaker' | 'fancy',
	): BetConfigEntry | null {
		if (!betConfig || !sportId) return null
		const mappingKey = this.getMappingKey(sportId, marketType)
		return betConfig[mappingKey] ?? betConfig[String(sportId)] ?? null
	}

	getMappingKey(sportId: number | string | undefined, marketType?: 'autoBm' | 'bookmaker' | 'fancy'): string {
		if (!sportId) return ''
		const id = Number(sportId)
		const isCricket = id === HOME_SPORT_GROUPS.CRICKET
		const isSoccer = id === HOME_SPORT_GROUPS.SOCCER
		const isTennis = id === HOME_SPORT_GROUPS.TENNIS

		if (marketType === 'autoBm') {
			if (isCricket) return 'Cricket-BF-BM'
			if (isSoccer) return 'Soccer-BF-BM'
			if (isTennis) return 'Tennis-BF-BM'
		} else if (marketType === 'bookmaker') {
			if (isCricket) return 'Cricket-Bookmaker'
		} else if (marketType === 'fancy') {
			if (isCricket) return 'Cricket-Fancy'
		}

		return String(sportId)
	}

	updateBetConfig(data: unknown) {
		let parsed = data

		if (typeof data === 'string') {
			try {
				parsed = JSON.parse(data)
			} catch {
				return
			}
		}

		const config = parsed as Record<string, BetConfigEntry>
		sessionStorage.setItem('betConfig', JSON.stringify(config))
		this.betConfig$.next(config)
	}

	clearBetConfig() {
		sessionStorage.removeItem('betConfig')
		this.betConfig$.next(null)
	}

	private loadFromStorage(): Record<string, BetConfigEntry> | null {
		const raw = sessionStorage.getItem('betConfig')
		if (!raw) return null
		try {
			return JSON.parse(raw)
		} catch {
			return null
		}
	}
}
